import {createSlice} from "@reduxjs/toolkit";

import {ErrorType} from "config/errors";
import {type BrandState, getBrand} from "utils/getBrand";

const brand = getBrand();

const error = !brand ? ErrorType.MISSING_BRAND : undefined;

export const initialState: BrandState = {
    brand,
    error,
};

export const slice = createSlice({
    name: "brand",
    initialState,
    reducers: {},
});

export default slice.reducer;
